import { Box, Stack, Theme, Typography, alpha, AlertTitle, Alert } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';

interface Props {
    overlappingMeasures: string[];
}

export default function InconsistenciesSlimWarning({ overlappingMeasures }: Props) {
    const count = overlappingMeasures.length;
    const measureWord = count === 1 ? 'measure' : 'measures';

    return (
        <Alert icon={<IconMi icon={'alert'} />} severity={'warning'} variant={'accent'}>
            <AlertTitle>
                <Box component={'strong'}>Potential inconsistency</Box>
            </AlertTitle>
            <strong>{count}</strong> {measureWord} in this report may be inconsistent with other reports you have access
            to: {overlappingMeasures.join(', ')}.
        </Alert>
    );
}
